import React from 'react';
import isNil from 'lodash-es/isNil';
import { gql } from '@yi/core';

import { graphql, useStaticQuery } from 'gatsby';
import { CourseCarousel } from '~/src/components/carousels/CourseCarousel';

import { sortCardsByIds } from '../sortCardsByIds';

interface Props {
  children: (data: React.ComponentProps<typeof CourseCarousel>['items']) => React.ReactNode;
}

const list = [
  '9I9qRaxhn0wIqFOsbBbgk',
  '8Qclndf97v9zkSWr7ADhh',
  '2jmajfpUJn5JfB4W2ViiBa',
  '7BORgXUUV69LEO20Z0df8a',
  '1fbVqxbNqi7T6EgVihqmW8',
  'npUuRbr30mSEVAR10wS65',
  '5J7DSaOAlHKlpW05Ab9nVy',
  '3506603',
  '185lN3gEqSrbYckce5nAHf',
  '185lN3gEqSrbYckce5nAHf',
  '5704949',
  '6OW6ZJsbRIgoa5Nj2gwt3v',
];

export const CoursesCarouselDataES: React.FC<Props> = ({ children }) => {
  const yiData = useStaticQuery<gql.typesSsr.Query_AllCourses_LOH_ES>(graphql`
    query Query_AllCourses_LOH_ES {
      yi {
        allCourses(
          filter: {
            ids: [
              "9I9qRaxhn0wIqFOsbBbgk"
              "8Qclndf97v9zkSWr7ADhh"
              "2jmajfpUJn5JfB4W2ViiBa"
              "7BORgXUUV69LEO20Z0df8a"
              "1fbVqxbNqi7T6EgVihqmW8"
              "npUuRbr30mSEVAR10wS65"
              "5J7DSaOAlHKlpW05Ab9nVy"
              "3506603"
              "185lN3gEqSrbYckce5nAHf"
              "185lN3gEqSrbYckce5nAHf"
              "5704949"
              "6OW6ZJsbRIgoa5Nj2gwt3v"
            ]
          }
        ) {
          ...Fragment_CourseCard
        }
      }
    }
  `);

  const data = yiData?.yi?.allCourses;
  if (isNil(data)) {
    return null;
  }
  const sortedClassesData = sortCardsByIds(data, list);

  return <>{children(sortedClassesData)}</>;
};
